import React from 'react';

import {Box} from 'goose-css';
import {Text} from 'goose-css';


class BoxChart extends React.Component {
    render() {
        const {value} = this.props;

        return <Box className="BoxChart">
            {value.map(({label, value, color}) => {
                return <Box
                    className="BoxChart_wrapper"
                    key={label}
                    style={{width: `${value * 100}%`}}
                >
                    <Text modifier="center block ellipsis" title={label}>{label}</Text>
                    <Box
                        style={{backgroundColor: color}}
                        className="BoxChart_cell"
                        children={`${Math.round(value * 100)}%`}
                    />
                </Box>
            })}
        </Box>;
    }
}

export default BoxChart;



// WEBPACK FOOTER //
// ./src/component/BoxChart.js